function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M36.2 35v-26.8c0-2.4-1.8-4.2-4.2-4.2h-2c-2.2 0-4.2 1.8-4.2 4.2v3.6l2.6 2.6-2.6 2.6v18",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M44 48.2c0 7.2-5.8 13-13 13s-13-5.8-13-13 5.8-13 13-13 13 5.8 13 13z",
  fill: "none",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.4 53.4c0 0.8-0.6 1.2-1.2 1.2s-1.2-0.6-1.2-1.2c0-0.8 0.6-1.2 1.2-1.2s1.2 0.4 1.2 1.2z",
  strokeMiterlimit: 10
}));

var SvgKey = function SvgKey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/key.01045a44.svg";
export { ForwardRef as ReactComponent };